export const DEVICE_SYNC_SSE_EVENTS = {
  DEVICE_CONNECTED: 'DEVICE_CONNECTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  PING: 'PING'
} as const;

export const SESSION_TIMEOUT_SECONDS = 600;
